import { render, staticRenderFns } from "./Bgreview.vue?vue&type=template&id=8a894ed2&scoped=true&"
import script from "./Bgreview.vue?vue&type=script&lang=js&"
export * from "./Bgreview.vue?vue&type=script&lang=js&"
import style0 from "./Bgreview.vue?vue&type=style&index=0&id=8a894ed2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a894ed2",
  null
  
)

export default component.exports